(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase()
  }

  function unlock(container) {
    container.classList.add('is-unlocked')
    container.setAttribute('data-unlocked', 'true')

    var locked = container.querySelector('[data-thanks-gate-locked]')
    var content = container.querySelector('[data-thanks-gate-content]')
    var status = container.querySelector('[data-thanks-gate-status]')

    if (locked) locked.hidden = true
    if (content) content.hidden = false

    if (status) {
      status.textContent = container.getAttribute('data-success-message') || ''
      status.hidden = false
    }
  }

  function showError(container) {
    var status = container.querySelector('[data-thanks-gate-status]')
    if (!status) return
    status.textContent = container.getAttribute('data-error-message') || ''
    status.hidden = false
  }

  function initGate(container) {
    var passphrase = normalize(container.getAttribute('data-passphrase'))
    var form = container.querySelector('[data-thanks-gate-form]')
    var input = container.querySelector('[data-thanks-gate-input]')

    if (!passphrase || !form || !input) return

    form.addEventListener('submit', function (event) {
      event.preventDefault()

      if (normalize(input.value) !== passphrase) {
        showError(container)
        input.focus()
        input.select()
        return
      }

      unlock(container)
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gates = document.querySelectorAll('[data-thanks-gate]')
    gates.forEach(initGate)
  })
})()
